import { render, staticRenderFns } from "./effective-tracking.vue?vue&type=template&id=d07dff76&scoped=true&"
import script from "./effective-tracking.vue?vue&type=script&lang=js&"
export * from "./effective-tracking.vue?vue&type=script&lang=js&"
import style0 from "./effective-tracking.vue?vue&type=style&index=0&id=d07dff76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07dff76",
  null
  
)

export default component.exports